export default __webpack_public_path__ + "static/media/babymilestoneImg5.30c46639.png";